<template>
    <span class="layout-cfcsl-item" v-bind:class="{'cur': itemData.choosed || choosed}" @click="clickItem">{{itemData.text}}</span>
</template>

<script>
export default {
    name: 'CommentTypeItem',
    props: ['parentData', 'itemData', 'itemFunc'],
    data() {
        return {
            choosed: false,
        }
    },
    mounted: function() {
        this.choosed = this.itemData.choosed;
    },
    methods: {
        clickItem() {
            var me = this;
            this.choosed = !this.choosed;
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(this.parentData, this.itemData, this.choosed, function(){
                    me.choosed = me.itemData.choosed;
                });
            }
        }
    }
}
</script>